import { SET_STATES_OPTION } from '../actions/stateOptions/types';

const initState = [];

const statesOption = (state = initState, action) => {
  switch (action.type) {
    case SET_STATES_OPTION:
      return action.payload;
    default:
      return state;
  }
};

export default statesOption;



// WEBPACK FOOTER //
// ./src/reducers/statesOption.js